export interface DeleteProjectCommitteeInput {
  projectId: string;
  committeeId: string;
}
